import { useOutletContext } from 'react-router-dom';
import type { Locale } from '@/lib/i18n/config';
import { getDictionary } from '@/lib/i18n/dictionaries';
import type { Dictionary } from '@/lib/i18n/dictionaries';
import type { SiteSettings } from '@/lib/supabase/types';

export type LocaleOutletContext = {
  locale: Locale;
  settings: SiteSettings | null;
};

export function useLocaleContext(): LocaleOutletContext & { dict: Dictionary } {
  const ctx = useOutletContext<LocaleOutletContext>();
  return { ...ctx, dict: getDictionary(ctx.locale) };
}
